import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CountriesDetailComponent } from './countries-detail/countries-detail.component';
import { CountriesListComponent } from './countries-list/countries-list.component';

const routes: Routes = [
  { path: "countries", component: CountriesListComponent },
  { path: "countries/:id", component: CountriesDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CountriesRoutingModule { }
